import WiseView from '../../../WiseView.vue';
import { frontendURL } from '../../../../../../helper/URLHelper';
import EditMessagesWise from './EditMessagesWise.vue';
export const routes = [
  {
    path: frontendURL('accounts/:accountId/wise/editmessage'),
    name: 'wise',
    roles: ['administrator'],
    component: WiseView,
    children: [
      {
        path: '',
        name: 'edit_message',
        component: EditMessagesWise,
        roles: ['administrator'],
      },
    ],
  },
];
